import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import { BRAND_COLORS, alpha } from '../../styles/theme';

interface AddEntityDialogProps {
  open: boolean;
  onClose: () => void;
  onAdd: (name: string) => Promise<void>;
  title: string;
  label: string;
  addingLabel?: string;
}

export const AddEntityDialog: React.FC<AddEntityDialogProps> = ({
  open,
  onClose,
  onAdd,
  title,
  label,
  addingLabel = 'Adding...',
}) => {
  const [name, setName] = useState('');
  const [adding, setAdding] = useState(false);

  const handleAdd = async () => {
    if (!name.trim()) return;
    try {
      setAdding(true);
      await onAdd(name.trim());
      setName('');
      onClose();
    } catch {
      // Error handling is done by the parent
    } finally {
      setAdding(false);
    }
  };

  const handleClose = () => {
    setName('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={label}
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && name.trim()) {
              handleAdd();
            }
          }}
          disabled={adding}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={adding}>
          Cancel
        </Button>
        <Button
          onClick={handleAdd}
          disabled={!name.trim() || adding}
          variant="contained"
          sx={{
            backgroundColor: BRAND_COLORS.forestGreen.main,
            '&:hover': { backgroundColor: alpha(BRAND_COLORS.forestGreen.main, 0.8) },
          }}
        >
          {adding ? addingLabel : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
